import type { FAQItem } from "@/lib/products";

/**
 * FAQ data for the Chrome Extension Screenshot Resizer tool
 */
export const chromeExtensionScreenshotResizerFAQ: FAQItem[] = [
  {
    question: "What screenshot sizes does the Chrome Web Store require?",
    answer:
      "The Chrome Web Store accepts screenshots at TWO official sizes: 640 x 400 pixels (1.6:1 aspect ratio) or 1280 x 800 pixels (also 1.6:1). You can mix sizes within one listing (some screenshots at 640x400, others at 1280x800) but each individual screenshot must match one of the two specs exactly. Other sizes are rejected by the upload validator.",
  },
  {
    question: "Why does the Web Store reject my screenshots?",
    answer:
      "Three common reasons: (1) Wrong dimensions — must be exactly 640x400 OR 1280x800 (no other ratios accepted), (2) Wrong file format — must be PNG or JPEG (no WebP, GIF, BMP), (3) Resolution mismatch — image dimensions in pixels must match what you claim, not just visually-cropped. The Web Store validates the actual pixel dimensions strictly. This tool guarantees your output is dimensionally exact.",
  },
  {
    question: "What if my source screenshot is a different aspect ratio?",
    answer:
      "The Web Store's required ratio is 1.6:1 (the same for both 640x400 and 1280x800). If your source is 16:9 (1.78:1), 16:10 (1.6:1, lucky!), or 4:3 (1.33:1), the tool fits your image with center-crop OR letterboxing. For 16:9 source: minor horizontal crop. For 4:3 source: significant vertical letterboxing (you might want to crop your source first instead). The tool defaults to center-cover; you can pre-crop your source if you want different framing.",
  },
  {
    question: "Should I use 640x400 or 1280x800?",
    answer:
      "Use 1280x800 whenever possible — it displays better in the Web Store's listing carousel (higher resolution, sharper on retina displays). Only use 640x400 if your source image is small (under 1280 wide). The Web Store displays both sizes at the same physical area but 1280x800 sources render with more detail on high-density displays.",
  },
  {
    question: "How many screenshots should my Chrome Web Store listing have?",
    answer:
      "Minimum: 1 (technical requirement). Recommended: 5 screenshots showing key features. Best practice: each screenshot shows ONE distinct value prop with a short overlaid caption. Listings with 5 well-designed screenshots convert significantly better than listings with 1 default screenshot. This tool generates the dimensions; you control the actual content + captions.",
  },
  {
    question: "Does the tool upload my screenshots anywhere?",
    answer:
      "No. All processing happens in your browser using JavaScript and HTML5 canvas. Your screenshots never leave your device — we don't upload, store, or access your files. The ZIP file is also generated locally. This matters for in-development extension screenshots showing features or branding you don't want public yet.",
  },
  {
    question: "Can I add text/captions to the screenshots in this tool?",
    answer:
      "Not currently — this tool focuses on dimensional correctness (the Web Store's strict requirement). For captions: design your screenshots with overlaid text in your design tool (Figma, Sketch, Photoshop, even Keynote) BEFORE uploading here. Then this tool ensures the final dimensions are Web Store-compliant. Captions added at design time look much better than captions added after the fact.",
  },
  {
    question: "Do I need to pay to use this tool?",
    answer:
      "No. The Chrome Extension Screenshot Resizer is 100% free with no signup, no watermarks, no premium tier. PlugMonkey provides free tools because we want to lower the friction for shipping Chrome extensions — a thriving ecosystem benefits everyone in it.",
  },
];
